<template>
   <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
             <el-breadcrumb-item @click.native="gohome" ><a>首页</a></el-breadcrumb-item>
          <el-breadcrumb-item>月缴单位</el-breadcrumb-item>
          <el-breadcrumb-item>单位名称变更保全</el-breadcrumb-item>
        </el-breadcrumb>
         <el-card id="card_st">
           <div slot="header" class="clearfix">
                <span style="font-size: 24px;font-weight: 500;">单位名称变更保全</span>
            </div>
            <div  style="padding-top: 10px;text-align: center;">
                <span style="color: red;">暂未开放</span>
              </div>
            
       
         </el-card>
        
        
    </div>
</template>

<script>

export default {
    methods:{
        //返回首页
        gohome() {
            window.sessionStorage.setItem('activePath', "/welcome");
            this.$router.push("/welcome");
            this.reload();   
        }
    }
   
}
</script>
<style lang="less" scoped>
    #card_st {
        width: 80%;
        margin: auto;
    }
</style>